
// ==========================================
// src/components/ProtectedRoute.js
// ==========================================

import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({
  children,
}) {
  const token = localStorage.getItem(
    "adminToken"
  );

  if (!token) {
    return <Navigate to="/login" />;
  }

  return children;
}
